import store from 'store'
import { getterTypes } from 'store/auth'

export default async (to, from, next) => {
  if (store.getters[getterTypes.status] === 'loading') {
    await new Promise(resolve => {
      const unwatch = store.watch(
        state => state.auth.status,
        status => {
          if (status !== 'loading') {
            unwatch()
            resolve()
          }
        }
      )
    })
  }

  if (store.getters[getterTypes.isLoggedIn] !== true) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }
  if (store.getters[getterTypes.isAdmin] === true) {
    return next()
  }
  return next({ name: 'Dashboard' })
}
